export enum DeviceType {
  Desktop = 1,
  Tablet = 2,
  Phone = 3
}
